import { projects } from '../../data/projects';
import { ui } from '../../data/ui';
import { SectionHeader } from '../ui/SectionHeader';
import { ProjectCard } from '../ui/ProjectCard';
import { Button } from '../ui/Button';
import './FeaturedProjects.css';

export function FeaturedProjects() {
  const featured = projects.filter((p) => p.featured).slice(0, 4);

  return (
    <section className="section featured-projects" id="projects">
      <div className="container">
        <SectionHeader
          label={ui.sections.portfolio}
          title={ui.sections.featuredProjects}
          subtitle={ui.sections.featuredProjectsSub}
        />

        <div className="projects-grid">
          {featured.map((project, i) => (
            <ProjectCard
              key={project.id}
              project={project}
              variant={i === 0 ? 'featured' : 'default'}
              index={i}
            />
          ))}
        </div>

        <div className="section-cta">
          <Button to="/projects" variant="ghost">
            {ui.sections.viewAllProjects} <span className="arrow">←</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
